export default __webpack_public_path__ + "files/FP6_Financial_Instruments_Quasi_Equity.pdf";